import { Component } from '@angular/core';
import { StatusButtons } from "../../../_shared/interfaces";
import { InvoicesOverviewComponent } from "./invoices-overview/invoices-overview.component";
import { NgForOf } from "@angular/common";

@Component({
  selector: 'app-invoices',
  standalone: true,
  imports: [
    InvoicesOverviewComponent,
    NgForOf
  ],
  templateUrl: './invoices.component.html',
  styleUrl: './invoices.component.sass'
})
export class InvoicesComponent {
  status: string = 'overdue';

  statusButtons: StatusButtons[] = [
    { state: 'all', display: 'Alle', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'partially', display: 'Teilbezahlt', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Fällig', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'paid', display: 'Bezahlt', label: 'alert-success', icon: 'check-circle'},
    { state: 'draft', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'cancelled', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  constructor() { }

  changeOverviewStatus(statusIndex: number){
    this.status = this.statusButtons[statusIndex].state;
  }
}
